import { useSelector } from 'react-redux';

import { cartHasGiftCards } from 'common/helpers/miscHelpers';
import { currencyFormat } from 'common/helpers/numberHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

const GiftCards = (props) => {
  const { cartOrOrder } = props;

  const { tenders } = cartOrOrder;

  if (!cartHasGiftCards(cartOrOrder)) {
    return null;
  }

  return (
    <>
      {tenders.map((tender) => (
        <GiftCard tender={tender} key={tender.id} />
      ))}
    </>
  );
};

const GiftCard = (props) => {
  const { tender } = props;
  const { t } = useLocalization();
  const settings = useSelector((state) => state.setting.data);

  const { currency } = settings;
  const { tenderType, amountTendered } = tender;

  if (tenderType === 'Gift Card' && amountTendered > 0) {
    return (
      <div className="c7-order-summary__item--notes">
        <div className="c7-order-summary__title">
          {t('checkout.general.paidByGiftCard')}
        </div>
        <div className="c7-order-summary__value">
          -{currencyFormat(amountTendered, currency)}
        </div>
      </div>
    );
  }
  return null;
};

export default GiftCards;
